import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { BackgroundJobScheduleDto } from "@/api/dtos";
import type { BackgroundJobSchedule, BackgroundJobScheduleInput } from "./_models/BackgroundJobSchedule";
import { toBackgroundJobScheduleFromBackgroundJobScheduleDto } from "./_transformers/toBackgroundJobScheduleFromBackgroundJobScheduleDto";
import { toBackgroundJobFetchError } from "./backgroundJob.utils";
import { BackgroundJobTags } from "./BackgroundJobTags";

export interface UpdateBackgroundJobScheduleArgs {
  id: string;
  schedule: BackgroundJobScheduleInput;
}

/** Replaces a schedule's settings or toggles it (PUT /background-job-schedules/{id}), and its EventBridge schedule. WRITE. */
export const updateBackgroundJobScheduleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateBackgroundJobSchedule: builder.mutation<BackgroundJobSchedule, UpdateBackgroundJobScheduleArgs>({
      queryFn: async (args) => {
        try {
          const res = await axios.put<BackgroundJobScheduleDto>(
            `${backendBase()}/background-job-schedules/${encodeURIComponent(args.id)}`,
            args.schedule,
            { headers: { Accept: "application/json" } },
          );
          const saved = toBackgroundJobScheduleFromBackgroundJobScheduleDto(res.data);
          return { data: saved };
        }
        catch (e) {
          return { error: toBackgroundJobFetchError(e) };
        }
      },
      invalidatesTags: [{ type: BackgroundJobTags.BackgroundJobSchedule, id: "LIST" }],
    }),
  }),
});

export const updateBackgroundJobSchedule = updateBackgroundJobScheduleApi.endpoints.updateBackgroundJobSchedule;
